import { createFileRoute } from "@tanstack/react-router";
import { EnvironmentsList } from "../../features/training/environments";
export const Route = createFileRoute("/_authed/$org/$project/environments/")({
  validateSearch: (s: Record<string, unknown>): { q?: string; category?: string; mode?: string; tab: "runs" | "environments" | "templates" } => ({
    q: typeof s.q === "string" ? s.q : undefined,
    category: typeof s.category === "string" ? s.category : undefined,
    mode: s.mode === "Train" || s.mode === "Evaluate" ? s.mode : undefined,
    tab: s.tab === "environments" || s.tab === "templates" ? s.tab : "runs",
  }),
  component: EnvironmentsPage,
});
function EnvironmentsPage() {
  const { org, project } = Route.useParams();
  const { q, tab, category, mode } = Route.useSearch();
  return <EnvironmentsList scope={{ org, project }} query={q} tab={tab} category={category} mode={mode} />;
}
